<p-dialog
    header="Impersonate User"
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [style]="{ width: '32rem' }"
    appendTo="body"
    (onShow)="onShow()"
>
    @if (visible()) {
        <div class="flex flex-col gap-4">
            <div class="flex flex-col gap-2">
                <label for="impersonationSubscriber" class="font-bold">Subscriber</label>
                <app-subscriber-select
                    id="impersonationSubscriber"
                    [subscriberKey]="selectedSubscriberKey()"
                    (subscriberKeyChange)="onSubscriberKeyChanged($event)"
                    [includeInternalSubscriber]="true"
                />
            </div>

            <div class="flex flex-col gap-2">
                <label for="impersonationUser" class="font-bold">User</label>
                <app-user-select
                    id="impersonationUser"
                    [subscriberKey]="selectedSubscriberKey()"
                    [userId]="selectedUserId()"
                    (userIdChange)="onUserIdChanged($event)"
                    [disabled]="selectedSubscriberKey() === null"
                    [includeSelf]="false"
                />
            </div>
        </div>

        <ng-template #footer>
            <div class="flex justify-end gap-2">
                <p-button severity="secondary" [outlined]="true" label="Cancel" (onClick)="close()" />
                <p-button
                    label="Impersonate"
                    [disabled]="selectedUserId() === null"
                    (onClick)="impersonate()"
                />
            </div>
        </ng-template>
    }
</p-dialog>
